import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangleRightFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 6,
	height: 8,
	viewBox: "0 0 6 8",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.65241 0.973504C1.65634 0.976127 1.66029 0.978758 1.66425 0.981397L5.13768 3.29531C5.23818 3.36225 5.33137 3.42431 5.40294 3.48199C5.47763 3.54218 5.56568 3.62565 5.61635 3.74775C5.68333 3.90915 5.68333 4.09053 5.61635 4.25192C5.56568 4.37403 5.47763 4.45749 5.40294 4.51768C5.33137 4.57536 5.23819 4.63742 5.1377 4.70436L1.65242 7.02616C1.52957 7.10801 1.41911 7.18161 1.32537 7.23237C1.23157 7.28317 1.10282 7.34121 0.952551 7.33225C0.760337 7.32078 0.582774 7.22582 0.466603 7.07237C0.375781 6.9524 0.352695 6.81315 0.342961 6.70699C0.333234 6.6009 0.333243 6.46824 0.333253 6.3207L0.333253 1.6932C0.333253 1.68844 0.333253 1.6837 0.333253 1.67897C0.333243 1.53144 0.333234 1.39877 0.342961 1.29268C0.352695 1.18652 0.375781 1.04728 0.466603 0.927307C0.582774 0.773854 0.760337 0.678895 0.952551 0.667427C1.10282 0.658461 1.23157 0.716506 1.32537 0.767302C1.4191 0.818061 1.52956 0.891657 1.65241 0.973504Z",
		fill: "#currentColor"
	})
});
export default SvgTriangleRightFilled;
